module.exports = __webpack_public_path__ + "static/media/Calendar-New-White.c3fc85bf.svg";